import { render, staticRenderFns } from "./LayoutWithoutMenu.vue?vue&type=template&id=6ba87410&scoped=true"
import script from "./LayoutWithoutMenu.vue?vue&type=script&lang=js"
export * from "./LayoutWithoutMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithoutMenu.vue?vue&type=style&index=0&id=6ba87410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba87410",
  null
  
)

export default component.exports